import { api } from './api';
import {
  AuditLog,
  AuditLogFilters,
  AuditLogResponse,
  AuditStats,
  AuditLogOptimized,
  AuditLogOptimizedFilters,
  AuditLogOptimizedResponse,
  AuditOptimizedStats,
  AuditAnomalies,
  StorageStats
} from '@/types/audit';

export const auditApi = {
  // Legacy audit methods
  getAuditLogs: (filters: AuditLogFilters = {}): Promise<AuditLogResponse> =>
    api.get('/audit-logs', { params: filters }).then(r => r.data),

  getAuditStats: (): Promise<AuditStats> =>
    api.get('/audit-logs/stats').then(r => r.data),

  exportAuditLogs: (filters: AuditLogFilters = {}): Promise<Blob> =>
    api.get('/audit-logs/export', { 
      params: filters,
      responseType: 'blob'
    }).then(r => r.data),

  getAuditLogById: (id: string): Promise<AuditLog> =>
    api.get(`/audit-logs/${id}`).then(r => r.data),

  // Optimized audit methods
  getOptimizedAuditLogs: (filters: AuditLogOptimizedFilters = {}): Promise<AuditLogOptimizedResponse> =>
    api.get('/audit-logs/optimized', { params: filters }).then(r => r.data),

  getOptimizedAuditStats: (): Promise<AuditOptimizedStats> =>
    api.get('/audit-logs/stats/optimized').then(r => r.data),

  getAnomalies: (): Promise<AuditAnomalies> =>
    api.get('/audit-logs/anomalies').then(r => r.data),

  getStorageStats: (): Promise<StorageStats> =>
    api.get('/audit-logs/storage-stats').then(r => r.data),

  exportOptimizedAuditLogs: (filters: AuditLogOptimizedFilters = {}): Promise<Blob> =>
    api.get('/audit-logs/export/optimized', { 
      params: filters,
      responseType: 'blob'
    }).then(r => r.data),

  getOptimizedAuditLogById: (id: string): Promise<AuditLogOptimized> =>
    api.get(`/audit-logs/optimized/${id}`).then(r => r.data),
};
